import { useEffect, useRef } from 'react';

import { SelectChangeEvent } from '@mui/material';

import { FirmwareOverviewModel } from '../../../../../../../shared/models/firmware-overview.model';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { filterFirmwaresByModel } from '../../../../../../firmware-management/store/slices/firmware.slice';

export const useFilteredSelectWithCheckboxesOnChange = (
  setFieldValue: (
    field: string,
    value: string | number[],
    shouldValidate?: boolean
  ) => void,
  options: FirmwareOverviewModel[],
  values: number[]
): ((event: SelectChangeEvent<number[]>) => void) => {
  const dispatch = useAppDispatch();
  const modelIdRef = useRef<number | null>(null);

  useEffect(() => {
    const [firmware] = options.filter(firm => firm.id === values[0]);
    const modelId = firmware?.model?.id;

    if (modelId && values.length && !modelIdRef.current) {
      modelIdRef.current = modelId;
      dispatch(filterFirmwaresByModel([modelId]));
    }
  }, [values, options, modelIdRef.current]);

  return (event: SelectChangeEvent<number[]>): void => {
    const value = event.target.value;

    if (!modelIdRef.current) {
      const [firmware] = options.filter(firm => firm.id === value[0]);
      modelIdRef.current = firmware.model.id;
      dispatch(filterFirmwaresByModel([modelIdRef.current]));
    }

    if (value.length === 0 && modelIdRef.current) {
      modelIdRef.current = null;
      dispatch(filterFirmwaresByModel([]));
    }

    setFieldValue('firmwareIds', value);
  };
};
